import { BadgeCheck, ShieldCheck, Zap, MapPinned } from "lucide-react";
import { Section, SectionHead } from "@/components/landing/Section";

const POINTS = [
  { icon: BadgeCheck, t: "Aucun abonnement", d: "Un paiement ponctuel, rien de récurrent." },
  { icon: ShieldCheck, t: "Paiement sécurisé via Stripe", d: "Vos données bancaires ne transitent jamais par Wanderlust." },
  { icon: Zap, t: "Accès rapide après paiement", d: "Un lien unique s'affiche immédiatement, sans compte." },
  { icon: MapPinned, t: "Proche et réaliste", d: "Rayon local, établissements bien notés, budget vérifié." },
];

export const Reassurance = () => (
  <Section id="reassurance">
    <SectionHead eyebrow="Réassurance" title="Simple, clair et sans engagement" />
    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
      {POINTS.map((p, i) => (
        <div key={p.t} data-testid={`reassurance-item-${i + 1}`}>
          <p.icon className="w-6 h-6 text-emerald-700" />
          <h3 className="mt-4 font-semibold text-[#0B131E]">{p.t}</h3>
          <p className="mt-1 text-sm text-gray-600 leading-relaxed">{p.d}</p>
        </div>
      ))}
    </div>
  </Section>
);
